import { Logger } from 'data/common';
import { fromJS, Map } from 'immutable';

function debug(eventName, params) {
    Logger.debug(`Fhe : <---------- Event Received ${eventName}`, params);
}

function handleProduct(ProductInstance, boxMac, productType, productMac, status) {
    const homeId = ProductInstance.getState().environments.fhe.data.Boxes.getIn(['list', boxMac, 'homeId'], null);
    if (!homeId) return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${boxMac}`);

    const home = ProductInstance.getState().environments.fhe.data.Homes.getIn(['list', homeId.toString()], null);
    const productsInit = home.getIn(['productsInitialized'], false);

    const productKey = `${homeId}_${productType}_${productMac}`;

    const product = ProductInstance.getState().environments.fhe.data.Products.getIn(['list', productKey], new Map());
    if (productsInit && product.size === 0) {
        if (status === 'connected') ProductInstance.emit('newProduct', homeId.toString(), productType, productMac);
    } else {
        ProductInstance.emit(`productStatusChange${boxMac}`, {
            productMac: productMac,
            productStatus: status,
            productType,
            productKey,
            productLabel: product.getIn(['label'], ''),
            displayType: product.getIn(['type'], '')
        });

        if (product.size > 0) {
            ProductInstance.dispatch({
                type: `FHE__PRODUCT_UPDATE_STATUS`,
                productKey,
                status
            });
        }
    }
}

function bindSettingsEvents(ProductInstance) {
    ProductInstance.socketOn('sensorStatus', function(args) {
        debug('sensorStatus', args);

        const { sensor_mac: fheProduct_mac, state: status, fheCenter_mac } = args;
        const productType = 'sensor';

        if (fheProduct_mac === undefined || status === undefined || fheCenter_mac === undefined)
            return Logger.error(`Arguments manquants sur l'event socket sensorStatus : "${args}"`);

        handleProduct(ProductInstance, fheCenter_mac, productType, fheProduct_mac, status);
    });
    ProductInstance.socketOn('smartPlugStatus', function(args) {
        debug('smartPlugStatus', args);

        const { wifiPlug_mac, status, fheCenter_mac } = args;
        const productType = 'smart_plug';

        if (wifiPlug_mac === undefined || status === undefined || fheCenter_mac === undefined)
            return Logger.error(`Arguments manquants sur l'event socket smartPlugStatus : "${args}"`);

        handleProduct(ProductInstance, fheCenter_mac, productType, wifiPlug_mac, status);
    });
    ProductInstance.socketOn('driveElecStatus', function(args) {
        debug('driveElecStatus', args);

        const { drive_elec_mac, state, fheCenter_mac } = args;
        const productType = 'drive_elec';

        if (drive_elec_mac === undefined || state === undefined || fheCenter_mac === undefined)
            return Logger.error(`Arguments manquants sur l'event socket driveElecStatus : "${args}"`);

        handleProduct(ProductInstance, fheCenter_mac, productType, drive_elec_mac, state);
    });
    ProductInstance.socketOn('fheProductStatus', function(args) {
        debug('fheProductStatus', args);

        const { fheProduct_type, fheProduct_mac, status, fheCenter_mac } = args;

        if (fheProduct_type === undefined || fheProduct_mac === undefined || status === undefined || fheCenter_mac === undefined)
            return Logger.error(`Arguments manquants sur l'event socket fheProductStatus : "${args}"`);

        handleProduct(ProductInstance, fheCenter_mac, fheProduct_type, fheProduct_mac, status);
    });

    ProductInstance.socketOn('productStatus', function(args) {
        const { fheCenter_mac, product_identifier: productIdentifier, product_type: productType, status } = args;
        debug('productStatus', args);
        if (!status) return false;

        if (fheCenter_mac === undefined || productIdentifier === undefined || productType === undefined)
            return Logger.error(`Arguments manquants sur l'envent socket productStatus : "${args}"`);

        handleProduct(ProductInstance, fheCenter_mac, productType, productIdentifier, status);
    });

    ProductInstance.socketOn('updateProductModuleLabel', function(args) {
        let { fheCenter_mac, product_identifier, product_type, module_type, code, label } = args;
        debug('updateProductModuleLabel', args);
        if (
            fheCenter_mac === undefined ||
            product_identifier === undefined ||
            product_type === undefined ||
            module_type === undefined ||
            code === undefined ||
            label === undefined
        )
            return Logger.error(`Arguments manquants sur l'envent socket updateProductModuleLabel : "${args}"`);
        const homeId = ProductInstance.getState().environments.fhe.data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);
        const productKey = `${homeId}_${product_type}_${product_identifier}`;
        const productModuleKey = `${product_type}_${product_identifier}_${code}`;
        if (!ProductInstance.getState().environments.fhe.data.Products.hasIn(['list', productKey]))
            return Logger.debug(`Le produit "${productKey}" n'est pas présent dans le store`);
        if (!ProductInstance.getState().environments.fhe.data.Products.hasIn(['list', productKey, 'productModules', productModuleKey]))
            return Logger.debug(`Le productModule "${productModuleKey}" n'est pas présent dans le store`);
        const form = { label };
        ProductInstance.dispatch({
            type: `FHE__PRODUCT_MODULE_UPDATE`,
            productKey,
            productModuleKey,
            form
        });
    });

    ProductInstance.socketOn('updateFheProductThreshold', function(args) {
        let { fheCenter_mac, product_identifier, module_type, thresholds_config } = args;
        debug('updateFheProductThreshold', args);
        if (fheCenter_mac === undefined || product_identifier === undefined || module_type === undefined || thresholds_config === undefined)
            return Logger.error(`Arguments manquants sur l'envent socket updateFheProductThreshold : "${args}"`);
        const homeId = ProductInstance.getState().environments.fhe.data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);
        const productKey = `${homeId}_fhe_product_${product_identifier}`;
        if (!ProductInstance.getState().environments.fhe.data.Products.hasIn(['list', productKey]))
            return Logger.debug(`Le produit "${productKey}" n'est pas présent dans le store`);
        let newThreshold = fromJS(thresholds_config);
        newThreshold.map((value, key) => {
            let productModuleKey = `fhe_product_${product_identifier}_${key}`;
            if (!ProductInstance.getState().environments.fhe.data.Products.hasIn(['list', productKey, 'productModules', productModuleKey]))
                return Logger.debug(`Le productModule "${productModuleKey}" n'est pas présent dans le store`);
            ProductInstance.dispatch({
                type: `FHE__FHEPRODUCT_THRESHOLD_UPDATE`,
                productKey,
                productModuleKey: productModuleKey,
                threshold: value
            });
        });
    });

    ProductInstance.socketOn('updateFheProductGain', function(args) {
        let { fheCenter_mac, product_identifier, module_type, gains_config } = args;
        debug('updateFheProductGain', args);
        if (fheCenter_mac === undefined || product_identifier === undefined || module_type === undefined || gains_config === undefined) {
            return Logger.error(`Arguments manquants sur l'event socket updateFheProductGain : "${args}"`);
        }
        const homeId = ProductInstance.getState().environments.fhe.data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) {
            return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);
        }
        const productKey = `${homeId}_fhe_product_${product_identifier}`;
        if (!ProductInstance.getState().environments.fhe.data.Products.hasIn(['list', productKey])) {
            return Logger.debug(`Le produit "${productKey}" n'est pas présent dans le store`);
        }
        let newGain = fromJS(gains_config);
        newGain.map((value, key) => {
            let productModuleKey = `fhe_product_${product_identifier}_${key}`;
            if (!ProductInstance.getState().environments.fhe.data.Products.hasIn(['list', productKey, 'productModules', productModuleKey])) {
                return Logger.debug(`Le productModule "${productModuleKey}" n'est pas présent dans le store`);
            }
            ProductInstance.dispatch({
                type: `FHE__FHEPRODUCT_GAIN_UPDATE`,
                productKey,
                productModuleKey: productModuleKey,
                gain: value
            });
        });
    });

    ProductInstance.socketOn('updateFheProductPolarity', function(args) {
        let { fheCenter_mac, product_identifier, module_type, reverse_polarity_config } = args;
        debug('updateFheProductPolarity', args);
        if (fheCenter_mac === undefined || product_identifier === undefined || module_type === undefined || reverse_polarity_config === undefined)
            return Logger.error(`Arguments manquants sur l'envent socket updateFheProductPolarity : "${args}"`);
        const homeId = ProductInstance.getState().environments.fhe.data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);
        const productKey = `${homeId}_fhe_product_${product_identifier}`;
        if (!ProductInstance.getState().environments.fhe.data.Products.hasIn(['list', productKey]))
            return Logger.debug(`Le produit "${productKey}" n'est pas présent dans le store`);
        let newPolarity = fromJS(reverse_polarity_config);
        newPolarity.map((value, key) => {
            let productModuleKey = `fhe_product_${product_identifier}_${key}`;
            if (!ProductInstance.getState().environments.fhe.data.Products.hasIn(['list', productKey, 'productModules', productModuleKey]))
                return Logger.debug(`Le productModule "${productModuleKey}" n'est pas présent dans le store`);
            ProductInstance.dispatch({
                type: `FHE__FHEPRODUCT_POLARITY_UPDATE`,
                productKey,
                productModuleKey: productModuleKey,
                polarity: value
            });
        });
    });
}

export default function initBinds(ProductInstance) {
    bindSettingsEvents(ProductInstance);
}



// WEBPACK FOOTER //
// ./environments/fhe/eventsSocket/Product/binds.js